import { useTranslation } from 'react-i18next';

import { CSVDownloader } from 'react-papaparse';

import { IconButton, DateTools, Tooltip } from '@treezor/design-system';

import { IBulkCard, IBulkCardCreationStatus } from '@/features/cards/store/models/bulk-card.model';

interface IActionsColumnProps {
  bulkCardCreation: IBulkCard;
}

export const ErrorReportAction = ({ bulkCardCreation }: IActionsColumnProps) => {
  const { t } = useTranslation();

  interface ICsvFormatedError {
    error: string;
  }

  const shapeIntoCsv = (bulkErrors, columnTitle) =>
    bulkErrors.reduce((acc: Array<ICsvFormatedError>, error) => [...acc, { [columnTitle]: error }], []);

  return (
    <Tooltip
      messageContent={
        bulkCardCreation.status === IBulkCardCreationStatus.COMPLETE_WITH_ERROR
          ? (t('pages.administration.bulkCards.tableActions.errorReport.titleError') as string)
          : (t('pages.administration.bulkCards.tableActions.errorReport.titleNoError') as string)
      }
      placement="top"
      contentClassName="w-[100px]"
    >
      {bulkCardCreation.status === IBulkCardCreationStatus.COMPLETE_WITH_ERROR ? (
        <CSVDownloader
          data={shapeIntoCsv(
            bulkCardCreation.errors,
            t('pages.administration.bulkCards.tableActions.errorReport.errorCsv', {
              orderId: bulkCardCreation.orderId,
            }),
          )}
          filename={`errors_report_${bulkCardCreation.orderId}_${DateTools.format(bulkCardCreation.createdAt, 'file')}`}
          className="p-0"
        >
          <IconButton icon="report" variant="tertiary" />
        </CSVDownloader>
      ) : (
        <IconButton icon="report" variant="tertiary" disabled />
      )}
    </Tooltip>
  );
};
